import headerlogo from "../../assets/images/logo.jpg";
import headerlogo2 from "../../assets/images/india_industrial.jpg";
import headerlogo3 from "../../assets/images/pngwing.com (1).png";
import uplodIcon from "../../assets/images/upload-image.png";
import { useState } from "react";
import { IoLocationSharp, IoMailSharp } from "react-icons/io5";
import { FaLocationDot } from "react-icons/fa6";
import { FaPhoneAlt } from "react-icons/fa";

const ExhibitinginWomenPCard = ({
  image,
  setImage,
  name,
  setName,
  error,
  setError,
}) => {
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(URL.createObjectURL(file));
      setError({ ...error, image: "" });
    }
  };

  const handleDeleteLogo = () => {
    setImage(null);
  };

  return (
    <>
      <div className="flex justify-center">
        <div className="card-main-div">
          <div className="card-header">
            <div className="card-header-content flex items-center justify-between">
              <img className="header-logo" src={headerlogo} alt="img1" />
              <img className="header-logo" src={headerlogo2} alt="img2" />
              <img className="header-logo" src={headerlogo3} alt="img3" />
            </div>
          </div>

          <div className="card-content">
            <div>
              <h1 className="text-md md:text-5xl text-white font-sans font-bold text-center ">
                11th INDIA INDUSTRIAL FAIR 2025
              </h1>
            </div>

            <div className="flex justify-center mt-2 md:mt-6">
              <div className="date-div">
                <p className="text-sm md:text-lg font-semibold">
                  10th - 13th January 2025
                </p>
              </div>
            </div>
            <div className="flex flex-col items-center justify-center">
              <div className="relative mt-4 md:mt-8">
                <input
                  type="file"
                  accept="image/*"
                  //value={formData?.image}
                  onChange={handleImageChange}
                  style={{ display: "none" }}
                />
                {image ? (
                  <>
                    <div className="deleteIcon " onClick={handleDeleteLogo}> ⛌ </div>
                    <img
                      className="exhibiting-uploaded-img"
                      src={image}
                      alt="Logo"
                    />
                  </>
                ) : (
                  <label className="">
                    <div className="flex flex-col items-center cursor-pointer exhibiting-img-upload-div ">
                      <input
                        type="file"
                        style={{ display: "none" }}
                        onChange={handleImageChange}
                      />
                      <img className="upload-icon" src={uplodIcon} alt="Upload Icon"></img>
                      <p className="text-xs md:text-md">Upload Image</p>
                    </div>
                  </label>
                )}
              </div>
              {/* <p className="text-red-800 text-sm mt-3">{error.image}</p> */}
              <input
                className="name-input mt-4"
                placeholder="Enter Company Name"
                type="text"
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                  setError({ ...error, name: "" });
                }}
              />
              {/* <p className="text-red-800 text-sm mt-3">{error.name}</p> */}
            </div>

            <div className="mt-4">
              <h4 className="exibiting-WP-text text-sm md:text-xl font-semibold">
                I AM EXHIBITING IN
              </h4>
              <div className="relative">
                <h2 className="exibiting-WP-text text-xl md:text-5xl font-bold ml-2 md:ml-16">
                  WOMEN PAVILLION
                </h2>
              </div>
            </div>
          </div>
          <div className="card-footer-section ">
            <div className="footer-content-div flex flex-col gap-2 md:gap-0 md:flex-row md:items-center md:justify-between">
              <div className="flex items-center gap-2">
                <div className="footer-icon-div">
                  <FaLocationDot color="#c86c03" />
                </div>
                <p className="text-xs font-semibold text-white">
                  DELHI PUBLIC SCHOOL, Bhuwana-Pratapnagar <br/> Bypass,
                  Udaipur, Rajasthan - 313001
                </p>
              </div>

              <div className="flex items-center gap-1">
                <div className="footer-icon-div flex">
                  <FaPhoneAlt color="#c86c03" />
                </div>
                <p className="text-xs font-semibold text-white">
                  +91-9982666712
                </p>
              </div>

              <div className="flex items-center gap-1">
                <div className="footer-icon-div flex">
                  <IoMailSharp color="#c86c03" />
                </div>
                <p className="text-xs font-semibold text-white">
                  iiflubudr@gmail.com
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ExhibitinginWomenPCard;
